var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M6 19H10V5H6V19ZM14 5V19H18V5H14Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }